export default __webpack_public_path__ + "d3d6c3cbe843e4b6bd3fcea48006524b.svg";